/*
 * @Author: bbqin
 * @Date: 2019-12-18 13:51:00
 * @LastEditTime: 2022-09-19 15:07:08
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
// 用于二次开发的快速扩展封装

import FastExtend from './core';

export { runInterval, getCheckedExtendMethod, preventEvent, preventDefault } from './adapters/page';
export { methodsInterceptor } from './adapters/component';
export { default as globalExtend } from './adapters/global';
export { default as routerExtend } from './adapters/router';
export { default as apiExtend } from './adapters/api';
export { default as registerExtendComponent } from './plugins/register';

export default FastExtend;